import { PhoneIcon } from '@chakra-ui/icons'
import { Link } from '@chakra-ui/react'
import { useMemo } from 'react'

import { Mobile } from '@/icons'

const mobilePhoneSegmentsRegex = /^(\d{3})(\d{3})(\d{3})$/
export const Phone = ({ number, phoneIcon, mobilePhoneIcon }: { number: string, phoneIcon?: boolean, mobilePhoneIcon?: boolean }) => {
  const mobilePhoneSegments = useMemo(() => number && number.match(mobilePhoneSegmentsRegex), [number])

  const formattedNumber = useMemo(() => mobilePhoneSegments ?
    `${mobilePhoneSegments[1]} ${mobilePhoneSegments[2]} ${mobilePhoneSegments[3]}`
    :
    number, [mobilePhoneSegments, number])

  return <Link display='flex' gap={2} _hover={{ textDecoration: 'none' }} href={`tel:${number}`}>
    {mobilePhoneIcon && <Mobile color="secondary.500" />}
    {phoneIcon && <PhoneIcon ml={1} mt={.5} mr={.5} color="secondary.500" />}
    {formattedNumber}
  </Link>
}